import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Shield } from 'lucide-react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setShow(true);
  }, []);

  const accept = async (level) => {
    localStorage.setItem('cookie_consent', level);
    setShow(false);
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API}/api/policies/cookie-consent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ consent: level }),
      });
    } catch (e) { /* handled */ }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[#0f172a] border border-gray-700 rounded-xl p-5 shadow-2xl flex flex-col md:flex-row items-center gap-4">
        <Shield className="w-8 h-8 text-[#D4A843] shrink-0" />
        <div className="flex-1 text-center md:text-left">
          <p className="text-sm text-white font-medium">We use cookies to improve your experience</p>
          <p className="text-[10px] text-gray-400 mt-0.5">Essential cookies keep you logged in. Analytics cookies help us improve. <a href="/policies" className="text-[#D4A843] hover:underline">Cookie Policy</a></p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button onClick={() => accept('essential_only')} variant="outline" size="sm" className="rounded-lg text-xs border-gray-600 text-gray-300 hover:bg-gray-800" data-testid="cookie-essential">Essential Only</Button>
          <Button onClick={() => accept('all')} size="sm" className="rounded-lg text-xs bg-[#D4A843] hover:bg-[#c49a3a] text-[#0f172a] font-bold" data-testid="cookie-accept-all">Accept All</Button>
        </div>
      </div>
    </div>
  );
}
